package com.ragnorak.clanybackoffice.ui.screens

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.clany.backoffice.domain.usecase.GetWebhookEventsUseCase
import com.clany.backoffice.model.SubscriptionWebhookEventResponse
import dev.zacsweers.metro.Inject
import kotlinx.coroutines.launch

data class WebhookEventsUiState(
    val isLoading: Boolean = false,
    val events: List<SubscriptionWebhookEventResponse> = emptyList(),
    val error: String? = null,
    val page: Int = 1,
    val hasMore: Boolean = true,
    val searchQuery: String = ""
)

class WebhookEventsViewModel @Inject constructor(
    private val getWebhookEventsUseCase: GetWebhookEventsUseCase
) : ViewModel() {

    var uiState by mutableStateOf(WebhookEventsUiState())
        private set

    init {
        loadEvents()
    }

    fun loadEvents(page: Int = 1) {
        viewModelScope.launch {
            uiState = uiState.copy(isLoading = true, error = null)
            getWebhookEventsUseCase(
                page = page,
                pageSize = 20,
                query = uiState.searchQuery.ifBlank { null }
            )
                .onSuccess { events ->
                    uiState = uiState.copy(
                        isLoading = false,
                        events = if (page == 1) events else uiState.events + events,
                        page = page,
                        hasMore = events.isNotEmpty()
                    )
                }
                .onFailure {
                    uiState = uiState.copy(isLoading = false, error = it.message)
                }
        }
    }

    fun onSearchQueryChanged(query: String) {
        uiState = uiState.copy(searchQuery = query)
        loadEvents(page = 1)
    }
}
